import Image from 'next/image';
import {
  HeaderHeadlinesStyled,
  HeadlineStyled,
  IconCloseStyled,
  ImageWrapperStyled,
  ModalCloseStyled,
  ModalHeaderStyled,
  RichTextStyled,
} from './ModalHouse.styles';
import { ModalContentProps } from './ModalHouse.types';

export const ModalContent: React.FC<ModalContentProps> = ({ data, onCloseCallback }) => {
  return (
    <>
      <ModalHeaderStyled>
        <HeaderHeadlinesStyled>
          <HeadlineStyled>{`${data.house_nr} ${data.name}`}</HeadlineStyled>
          <div>{data.ort}</div>
        </HeaderHeadlinesStyled>

        <ModalCloseStyled onClick={onCloseCallback}>
          <IconCloseStyled name="CLOSE" />
        </ModalCloseStyled>
      </ModalHeaderStyled>
      <div>
        {!!(data.image && data.image.url && data.image.dimensions?.width) && (
          <ImageWrapperStyled>
            <Image
              src={data.image.url}
              alt={data.image.alt || ''}
              height={data.image.dimensions.height}
              width={data.image.dimensions.width}
            />
          </ImageWrapperStyled>
        )}
        {data && <RichTextStyled rich_text={data.description} />}
      </div>
    </>
  );
};
